import React from "react";
import type { RouteObject } from "react-router-dom";
import type { ModuleOptions } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import type { MarketingCompanyResource } from "@exonn/js-sdk";

const customersRoute: RouteObject = {
  lazy: () =>
    import(
      "src/admin/modules/marketing-company/routes/edit/tabs/customers/customers.route.tsx"
    ),
};

export const module: ModuleOptions<MarketingCompanyResource> = {
  resource: ResourceEnum.MarketingCompany,
  bigIcon: <i className="icon-20-market_comp" />,
  smallIcon: <i className="icon-15-market_comp" />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
  list: {
    hideDeleteAction: (row) => {
      return !!row.finished_at;
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    customers: {
      title: (t) => t("formTabs.customers.title"),
      routeObject: customersRoute,
    },
    outcome: {
      title: (t) => t("formTabs.outcome.title"),
    },
    email: {
      title: (t) => t("formTabs.email.title"),
    },
    sms: {
      title: (t) => t("formTabs.sms.title"),
    },
    whatsapp: {
      title: (t) => t("formTabs.whatsapp.title"),
    },
    letter: {
      title: (t) => t("formTabs.letter.title"),
    },
  },
};
